import Transition from "./Transition";

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3.transition
 */
export default class FadeTransition extends Transition {
    /**
     * @param {number} [color]
     * @param {number} [duration]
     */
    constructor(color, duration) {
        super();

        /**
         * @member {number}
         * @private
         */
        this._color = color || 0x0;

        /**
         * @member {number}
         * @private
         */
        this._duration = duration || 0.8;

        /**
         * @member {PIXI.Graphics}
         * @private
         */
        this._quad = null;
    }

    init() {
        super.init();

        this._quad = new PIXI.Graphics();
        this._quad.visible = false;
        this.addChild(this._quad);

        this.resize();
    }

    /**
     * @param {number} [delay=0]
     */
    in(delay = 0) {
        this._quad.alpha = 0;
        this._quad.visible = true;
        TweenMax.to(this._quad, this._duration * 0.5, {
            delay: delay,
            alpha: 1,
            ease: Power2.easeInOut,
            onComplete: function() {
                this.signals.in.dispatch(this);
            },
            onCompleteScope: this
        });
    }

    /**
     * @param {number} [delay=0.5]
     */
    out(delay = 0.5) {
        TweenMax.to(this._quad, this._duration * 0.5, {
            delay: delay,
            alpha: 0,
            ease: Power2.easeInOut,
            onComplete: function() {
                this._quad.visible = false;
                this.signals.out.dispatch(this);
            },
            onCompleteScope: this
        });
    }

    resize() {
        this._quad.clear();
        this._quad.beginFill(this._color);
        this._quad.drawRect(0, 0, P3.View.width, P3.View.height);
        this._quad.endFill();
    }

    /**
     * @returns {number}
     */
    get color() {
        return this._color;
    }

    /**
     * @returns {number}
     */
    get duration() {
        return this._duration;
    }
}
